module.exports = __webpack_public_path__ + "static/media/ticket.82721c33.png";